<template>
  <b-row>
    <b-col>
      <b-row class="border-bottom text-left py-2">
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[0])"
            :id="bloodChemistryTests[0].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[0].name"
            :value="bloodChemistryTests[0]"
            >{{ bloodChemistryTests[0].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[1])"
            :id="bloodChemistryTests[1].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[1].name"
            :value="bloodChemistryTests[1]"
            >{{ bloodChemistryTests[1].name }}</b-form-checkbox
          >
        </b-col>
      </b-row>
      <b-row class="border-bottom text-left py-2">
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[2])"
            :id="bloodChemistryTests[2].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[2].name"
            :value="bloodChemistryTests[2]"
            >{{ bloodChemistryTests[2].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[3])"
            :id="bloodChemistryTests[3].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[3].name"
            :value="bloodChemistryTests[3]"
            >{{ bloodChemistryTests[3].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[4])"
            :id="bloodChemistryTests[4].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[4].name"
            :value="bloodChemistryTests[4]"
            >{{ bloodChemistryTests[4].name }}</b-form-checkbox
          >
        </b-col>
      </b-row>
      <b-row class="border-bottom text-left py-2">
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[5])"
            :id="bloodChemistryTests[5].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[5].name"
            :value="bloodChemistryTests[5]"
            >{{ bloodChemistryTests[5].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[6])"
            :id="bloodChemistryTests[6].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[6].name"
            :value="bloodChemistryTests[6]"
            >{{ bloodChemistryTests[6].name }}</b-form-checkbox
          >
        </b-col>
      </b-row>
      <b-row class="border-bottom text-left py-2">
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[7])"
            :id="bloodChemistryTests[7].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[7].name"
            :value="bloodChemistryTests[7]"
            >{{ bloodChemistryTests[7].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[8])"
            :id="bloodChemistryTests[8].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[8].name"
            :value="bloodChemistryTests[8]"
            >{{ bloodChemistryTests[8].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[9])"
            :id="bloodChemistryTests[9].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[9].name"
            :value="bloodChemistryTests[9]"
            >{{ bloodChemistryTests[9].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[10])"
            :id="bloodChemistryTests[10].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[10].name"
            :value="bloodChemistryTests[10]"
            >{{ bloodChemistryTests[10].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[11])"
            :id="bloodChemistryTests[11].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[11].name"
            :value="bloodChemistryTests[11]"
            >{{ bloodChemistryTests[11].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[12])"
            :id="bloodChemistryTests[12].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[12].name"
            :value="bloodChemistryTests[12]"
            >{{ bloodChemistryTests[12].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[13])"
            :id="bloodChemistryTests[13].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[13].name"
            :value="bloodChemistryTests[13]"
            >{{ bloodChemistryTests[13].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-8">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[14])"
            :id="bloodChemistryTests[14].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[14].name"
            :value="bloodChemistryTests[14]"
            >{{ bloodChemistryTests[14].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[15])"
            :id="bloodChemistryTests[15].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[15].name"
            :value="bloodChemistryTests[15]"
            >{{ bloodChemistryTests[15].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[16])"
            :id="bloodChemistryTests[16].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[16].name"
            :value="bloodChemistryTests[16]"
            >{{ bloodChemistryTests[16].name }}</b-form-checkbox
          >
        </b-col>
      </b-row>
      <b-row class="border-bottom text-left py-2">
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[17])"
            :id="bloodChemistryTests[17].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[17].name"
            :value="bloodChemistryTests[17]"
            >{{ bloodChemistryTests[17].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[18])"
            :id="bloodChemistryTests[18].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[18].name"
            :value="bloodChemistryTests[18]"
            >{{ bloodChemistryTests[18].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[19])"
            :id="bloodChemistryTests[19].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[19].name"
            :value="bloodChemistryTests[19]"
            >{{ bloodChemistryTests[19].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[20])"
            :id="bloodChemistryTests[20].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[20].name"
            :value="bloodChemistryTests[20]"
            >{{ bloodChemistryTests[20].name }}</b-form-checkbox
          >
        </b-col>
      </b-row>
      <b-row class="text-left py-2">
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[21])"
            :id="bloodChemistryTests[21].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[21].name"
            :value="bloodChemistryTests[21]"
            >{{ bloodChemistryTests[21].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[22])"
            :id="bloodChemistryTests[22].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[22].name"
            :value="bloodChemistryTests[22]"
            >{{ bloodChemistryTests[22].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[23])"
            :id="bloodChemistryTests[23].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[23].name"
            :value="bloodChemistryTests[23]"
            >{{ bloodChemistryTests[23].name }}</b-form-checkbox
          >
        </b-col>
        <b-col class="col-lg-4">
          <b-form-checkbox
            v-if="checkArray(bloodChemistryTests[24])"
            :id="bloodChemistryTests[24].name"
            v-model="testSelectedComputed"
            :name="bloodChemistryTests[24].name"
            :value="bloodChemistryTests[24]"
            >{{ bloodChemistryTests[24].name }}</b-form-checkbox
          >
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import _ from "lodash";

export default {
  name: "BloodChemistryTestChecklistComponent",
  props: {
    tests: {
      required: true,
    },
    testSelected: {
      required: true,
    },
    isOutLab: {},
  },
  computed: {
    testSelectedComputed: {
      get() {
        return this.testSelected;
      },
      set(value) {
        this.$emit("update:testSelected", value);
      },
    },
    bloodChemistryTests() {
      let bcTests = [...this.tests];
      if (bcTests.length < 25) {
        let number = 25 - bcTests.length;
        let emptyArray = new Array(number);
        bcTests = [...bcTests, ...emptyArray];
      }

      return bcTests;
    },
  },
  methods: {
    checkArray(value) {
      let boolean = !_.isUndefined(value);
      if (boolean) {
        boolean =
          value.lab_type == (this.isOutLab ? "outlab" : "inlab") ||
          value.lab_type == null;
      }
      return boolean;
    },
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: none !important;
}
</style>
